// eslint-disable-next-line no-restricted-imports
import type BlueBirdPromise from 'bluebird';
import type { FunctionComponent } from 'react';

import type { PIIString } from '@trello/privacy';

import { ConfirmedUserText } from './ConfirmedUserText';
import { InvalidEmailText } from './InvalidEmailText';
import { UnconfirmedUserText } from './UnconfirmedUserText';

interface LoggedInUserTextProps {
  isConfirmed: boolean;
  hasValidEmail: boolean;
  hasValidManagedStatus: boolean;
  willJoinOnConfirm: boolean;
  fullName: PIIString;
  returnUrl: string;
  modelName: 'Board' | 'Team';
  fxJoin: (traceId: string) => BlueBirdPromise<void>;
  setErrorMessage: (message: string) => void;
  setIsEnterpriseError: (hasError: boolean) => void;
  setIsWorkspaceInviteRestrictionError: (hasError: boolean) => void;
  analyticsContainers: {
    [key: string]: {
      id: string;
    };
  };
  requiredDomain: string | null;
  emailRestrictions: string[];
  setPendingEmail: (email: string) => void;
  fxQueueJoin: () => void;
}

export const LoggedInUserText: FunctionComponent<LoggedInUserTextProps> = ({
  isConfirmed,
  hasValidEmail,
  hasValidManagedStatus,
  fullName,
  returnUrl,
  modelName,
  fxJoin,
  setErrorMessage,
  setIsEnterpriseError,
  setIsWorkspaceInviteRestrictionError,
  analyticsContainers,
  requiredDomain,
  emailRestrictions,
  setPendingEmail,
  willJoinOnConfirm,
  fxQueueJoin,
}) => {
  if (!hasValidEmail && !hasValidManagedStatus) {
    return (
      <InvalidEmailText
        returnUrl={returnUrl}
        requiredDomain={requiredDomain}
        emailRestrictions={emailRestrictions}
        setPendingEmail={setPendingEmail}
      />
    );
  }

  if (isConfirmed) {
    return (
      <ConfirmedUserText
        fullName={fullName}
        returnUrl={returnUrl}
        modelName={modelName}
        fxJoin={fxJoin}
        setErrorMessage={setErrorMessage}
        setIsEnterpriseError={setIsEnterpriseError}
        setIsWorkspaceInviteRestrictionError={
          setIsWorkspaceInviteRestrictionError
        }
        analyticsContainers={analyticsContainers}
      />
    );
  }

  return (
    <UnconfirmedUserText
      willJoinOnConfirm={willJoinOnConfirm}
      fxQueueJoin={fxQueueJoin}
    />
  );
};
